import PropTypes from 'prop-types';
import LoadingButton from '@mui/lab/LoadingButton';

// Light blue button w. darker border
// Used for primary actions
// Uses LoadingButton to handle optional loading states

//  --- props ---
// - onClick: Function to handle button click (should have either onClick or href)
// - label: String to display on the button
// - key: String to use as the button's key
// - href: String to use as the button's href (optional, defaults to '')
// - loading: Boolean to indicate if the button is in a loading state (optional)
// - disabled: Boolean to indicate if the button is disabled (optional)

const PrimaryButton = ({
	onClick,
	label,
	loading = false,
	disabled = false,
	href = '',
	...rest
}) => {
	return (
		<LoadingButton
			{...rest}
			variant='outlined'
			size='small'
			onClick={onClick}
			href={href}
			target={href ? '_blank' : undefined}
			rel={href ? 'noopener noreferrer' : undefined}
			loading={loading}
			disabled={disabled || loading}
			sx={{
				fontSize: '12px',
				fontWeight: 500,
				padding: '7px 14px',
				borderRadius: '6px',
				backgroundColor: 'status.blue.bg',
				color: 'status.blue.text',
				borderColor: 'status.blue.border',
				cursor: 'pointer',
				flexShrink: 0,
				'&:hover': { backgroundColor: 'status.blue.hover' },
				'&.Mui-disabled:not(.MuiLoadingButton-loading)': {
					backgroundColor: 'background.subtle',
					color: 'text.tertiary',
					borderColor: 'border.light',
				},
			}}
		>
			{label}
		</LoadingButton>
	);
};

PrimaryButton.propTypes = {
	onClick: PropTypes.func,
	href: PropTypes.string,
	loading: PropTypes.bool,
	label: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};

export default PrimaryButton;
